export default __webpack_public_path__ + "images/icons/menu-3f9ec13027ecf6a5267d4b02d5fd2fb4.svg";